import { jwtDecode } from "jwt-decode";

/** Token süresinin dolmasına bu süreden az kaldıysa geçersiz sayılır. */
const EXPIRY_LEEWAY_MS = 1000 * 60;

/**
 * JWT'nin biçimsel olarak çözülebildiğini ve süresinin dolmadığını doğrular.
 * Çözülemeyen veya süresi geçmiş token için false döner.
 */
export const isTokenValid = (token?: string | null): boolean => {
  if (!token) return false;

  try {
    const { exp } = jwtDecode<{ exp?: number }>(token);
    if (!exp) return false;

    return exp * 1000 - Date.now() > EXPIRY_LEEWAY_MS;
  } catch {
    return false;
  }
};

/**
 * İsteğe eklenecek token'ı döner. Geçerli token yoksa undefined döner ve
 * Authorization header'ı hiç gönderilmez; 401 yanıtını rtkQueryErrorHandler
 * yakalayıp oturumu kapatır.
 */
export const getToken = (auth?: { token?: string }): string | undefined =>
  isTokenValid(auth?.token) ? auth?.token : undefined;
